import React from 'react';
import Footer from '../components/Footer.js';
import Navbar from '../components/navbar/Navbar.js';
import ContactForm from '../components/contact/ContactForm.js';
import { useSEO } from '../components/CustomHook';

const Contact = () => {
    useSEO(
        "Kontakt - Schmid Energieberatung | Energieberatung & Beratungstermin",
        "Kontaktieren Sie Schmid Energieberatung für eine persönliche Energieberatung. Vereinbaren Sie einen Termin für Wärmepumpen, Solaranlagen und erneuerbare Energien.",
        "Kontakt, Energieberatung, Beratungstermin, Wärmepumpe Beratung, Solaranlage Beratung, Energieberater",
        "/logo512.png"
    );

    return (
        <>
            <Navbar />
            <div className="mt-16">
                <div className="container mx-auto px-4">
                    <h1 className="text-4xl font-bold text-center mb-8">
                        Kontaktieren Sie uns
                    </h1>
                    <p className="text-xl text-center mb-12 text-gray-600">
                        Vereinbaren Sie einen persönlichen Beratungstermin für Ihre Energiewende
                    </p>
                </div>
            </div>
            <ContactForm />
            <div className="mt-32"></div>
            <Footer />
        </>
    )
}

export default Contact;